import { SEARCH_CHANGED, STATUS_CHANGED } from "./actionTypes";

export const statusChanged = (status) => {
  return {
    type: STATUS_CHANGED,
    payload: status,
  };
};

export const searchChanged = (searchText) => {
  return {
    type: SEARCH_CHANGED,
    payload: searchText,
  };
};
